import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['getApplyId']),
    isXuniSku() {
      let goodsClassify = this.goodsInfo.spuType
      return ['2', '3', '4'].includes(goodsClassify)
    }
  },
  data() {
    return {
      userInfo: this.$service.state.user,
      goodsInfo: {},
      groupCode: '',
      orderSn: '',
      sharePicPop: false,
      showPop: false,
      sharePic: null,
      endTime: 0,
      lastNum: 0,
      showShare: false
    }
  },
  methods: {
    getShareLink() {
      // 这里接口要求不能带ordersn,判断当前用户是否是参团的,需要通过接口返回是否有ordersn.
      // 如果这里带了ordersn
      return `${location.origin}/ad-link/ccfx?target=${encodeURIComponent(
        location.origin + '/collageDetail'
      )}&pageType=collage&groupCode=${this.groupCode}&shareApplyId=${this.getApplyId}`
    },
    weChatCollage() {
      let link = this.getShareLink()
      this.$wxSdk({
        title: '点击进来，参加我的拼团吧！',
        desc: this.goodsInfo.title,
        link: link,
        imgUrl: this.goodsInfo.skuThumb
      }).catch(error => {
        console.log('微信分享失败', error)
      })
      this.$service.growthValueTask({
        taskType: '100702'
      })
      this.showShare = true
      this.showPop = false
    },
    goRule() {
      this.$router.push('/collageRules')
    },
    goHome() {
      this.$router.push({ name: 'store-home' })
    },
    async shareCollage(endTime, groupCode, lastNum) {
      let shengluehao =
                'https://img2.coocaa.com/ui/partner-mini-program/20220422-172034.png'
      let pintuanjia =
                'https://img2.coocaa.com/ui/partner-mini-program/20220422-172030.png'
      // 虚拟SKU：入口支持“生成海报”；用户打开链接，默认进H5。
      let qrcode = this.getShareLink()

      // 实物SKU：入口支持“微信好友，生成海报”；用户打开链接，默认进小程序。
      if (!this.isXuniSku) {
        qrcode = '2019'
      }
      // console.log('111',this.skillPrice,this.goodsInfo.shopPrice);
      let skillPrice
      if (this.skillPrice) {
        skillPrice = Number(this.skillPrice).toFixed(2)
      } else {
        skillPrice = Number(this.goodsInfo.shopPrice || 0).toFixed(2)
      }
      // 根据优惠价的长短设置原价
      let yuanjiaX = 31 + 4 * `${skillPrice}`.length
      // 测试
      let goodsName1 = ''
      let goodsName2 = ''
      let newDian = ''
      // 如果大于17长度,就分解为2行
      for (let a = 0; a < this.goodsInfo.title.length; a++) {
        if (a < 17) {
          goodsName1 = `${goodsName1}${this.goodsInfo.title.charAt(a)}`
        } else if (a < 33) {
          goodsName2 = `${goodsName2}${this.goodsInfo.title.charAt(a)}`
        } else {
          newDian = '...'
          break
        }
      }
      goodsName2 += newDian
      const date = new Date(endTime)
      const fmt = 'MM-dd hh:mm:ss'
      endTime = this.formatDate(date, fmt)
      let qrSize = 56
      // 测试
      // lastNum = 10000
      let lastTxt = String(lastNum)
      let len = lastTxt.length
      let lastRight = 27.5
      let scene = `t=6&id=${this.groupCode}`
      if (this.getApplyId) {
        scene += `&aid=${this.getApplyId}`
      }
      for (let a = 0; a < lastTxt.length; a++) {
        // 如果金额小于10元
        switch (len) {
          case 1:
            if (lastNum == 1) {
              lastRight = 26
            } else {
              lastRight = 27
            }
            break
          case 2:
            if (lastTxt.charAt(a) == 1) {
              lastRight += 0.5
            } else {
              lastRight += 0.8
            }
            break
          case 3:
            if (lastTxt.charAt(a) == 1) {
              lastRight += 0.9
            } else {
              lastRight += 1
            }
            break
          case 4:
            if (lastTxt.charAt(a) == 1) {
              lastRight += 1.3
            } else {
              lastRight += 1.3
            }
            break
          case 5:
            if (lastTxt.charAt(a) == 1) {
              lastRight += 1.3
            } else {
              lastRight += 1.4
            }
            break
          default:
            if (lastTxt.charAt(a) == 1) {
              lastRight += 1.5
            } else {
              lastRight += 1.5
            }
            break
        }
      }
      // let hhh = 464 * 4;
      // let www = 298 * 4;
      let www = 590 * 2
      let hhh = 928 * 2
      let combineParam = {
        action: 'combie',
        backgroundColor: '000000',
        backgroundWidth: 590 * 2,
        backgroundHeight: 928 * 2,
        items: [
          {
            context: 'https://img2.coocaa.com/ui/partner-mini-program/shareBg.png',
            coordinateX: 0,
            coordinateY: 0,
            shapeHeight: 928 * 2,
            shapeWidth: 590 * 2,
            type: 'image'
          },
          {
            context: this.userInfo.headUrl,
            coordinateX: (7 / 100) * www,
            coordinateY: (3 / 100) * hhh,
            shapeHeight: 20 * 4,
            shapeWidth: 20 * 4,
            type: 'image',
            cornerRadius: 50
          },
          {
            context: '邀请你来参加我的拼团，快来吧！',
            coordinateX: (15 / 100) * www,
            coordinateY: (6 / 100) * hhh,
            fontColor: 'ffffff',
            fontSize: 10 * 4,
            textLineHeight: 10 * 4,
            type: 'text'
          },
          {
            context: this.goodsInfo.skuThumb,
            coordinateX: (11 / 100) * www,
            coordinateY: (12 / 100) * hhh,
            shapeHeight: 231 * 4,
            shapeWidth: 231 * 4,
            coordinateCenter: true,
            type: 'image'
          },
          {
            context: pintuanjia,
            coordinateX: (10 / 100) * www,
            coordinateY: (64 / 100) * hhh,
            shapeHeight: 16 * 4,
            shapeWidth: 38 * 4,
            type: 'image'
          },
          {
            context: '¥',
            coordinateX: (24 / 100) * www,
            coordinateY: (67.5 / 100) * hhh,
            fontColor: 'FC4C00',
            fontSize: 14 * 4,
            textLineHeight: 14 * 4,
            type: 'text'
          },
          {
            context: `${skillPrice}`,
            coordinateX: (28 / 100) * www,
            coordinateY: (68 / 100) * hhh,
            fontColor: 'FC4C00',
            fontSize: 20 * 4,
            textLineHeight: 20 * 4,
            type: 'text'
          },
          {
            context: `原价¥${Number(this.goodsInfo.marketPrice || 0).toFixed(
              2
            )}`,
            coordinateX: (yuanjiaX / 100) * www,
            coordinateY: (67.5 / 100) * hhh,
            fontColor: '999999',
            fontSize: 10 * 4,
            textLineHeight: 10 * 4,
            strikethrough: true,
            type: 'text'
          },
          {
            context: goodsName1,
            coordinateX: (11 / 100) * www,
            coordinateY: (72 / 100) * hhh,
            shapeWidth: 80 * 4,
            shapeHeight: 100 * 4,
            fontColor: '000000',
            fontSize: 14 * 4,
            textLineHeight: 20 * 4,
            type: 'text'
          },
          {
            context: qrcode,
            coordinateX: (74.5 / 100) * www,
            coordinateY: (85.5 / 100) * hhh,
            shapeHeight: qrSize * 4,
            shapeWidth: qrSize * 4,
            // cornerRadius: 50,
            type: 'qrcode'
          },
          {
            context: shengluehao,
            coordinateX: (10 / 100) * www,
            coordinateY: (78 / 100) * hhh,
            shapeHeight: 16 * 4,
            shapeWidth: 16 * 4,
            type: 'image'
          },
          {
            context: `仅限`,
            coordinateX: (17 / 100) * www,
            coordinateY: (80 / 100) * hhh,
            fontColor: '000000',
            fontSize: 10 * 4,
            textLineHeight: 20 * 4,
            type: 'text'
          },
          {
            context: `${lastNum}`,
            coordinateX: (24 / 100) * www,
            coordinateY: (80 / 100) * hhh,
            fontColor: 'FC4C00',
            fontSize: 10 * 4,
            textLineHeight: 20 * 4,
            type: 'text'
          },
          {
            context: `个名额`,
            coordinateX: (lastRight / 100) * www,
            coordinateY: (80 / 100) * hhh,
            fontColor: '000000',
            fontSize: 10 * 4,
            textLineHeight: 20 * 4,
            type: 'text'
          },
          {
            context: endTime + ' 结束',
            coordinateX: (55 / 100) * www,
            coordinateY: (80 / 100) * hhh,
            fontColor: '000000',
            fontSize: 10 * 4,
            textLineHeight: 20 * 4,
            type: 'text'
          },
          {
            context: '长按识别购买',
            coordinateX: (7 / 100) * www,
            coordinateY: (89 / 100) * hhh,
            fontColor: 'ffffff',
            fontSize: 14 * 4,
            textLineHeight: 30 * 4,
            type: 'text'
          },
          {
            context: '立即参与拼团',
            coordinateX: (7 / 100) * www,
            coordinateY: (93 / 100) * hhh,
            fontColor: 'ffffff',
            fontSize: 12 * 4,
            textLineHeight: 30 * 4,
            type: 'text'
          }
        ],
        miniProgramQrCodes: [
          {
            id: 2019,
            isHyaline: false,
            lineColor: { r: 255, g: 255, b: 255 },
            page: 'pages/utils/bindEmp',
            scene,
            width: 180,
            appId: 'wx91219bd99f3f07c2'
          }
        ]
      }

      if (goodsName2) {
        combineParam.items.splice(7, 0, {
          context: goodsName2,
          coordinateX: (11 / 100) * www,
          coordinateY: (75 / 100) * hhh,
          shapeWidth: 80 * 4,
          shapeHeight: 100 * 4,
          fontColor: '000000',
          fontSize: 14 * 4,
          textLineHeight: 20 * 4,
          type: 'text'
        })
      }
      let error = combineParam.items.find(item => item.context == '')
      if (error) {
        console.log('入参有误,content为空', error)
        if (!this.goodsInfo.skuThumb) {
          console.log('没有上架图')
          error.context = 'http://img2.coocaa.com/images/coocaa-shop.jpg'
        }
      }
      // 实物SKU：入口支持“微信好友，生成海报”；用户打开链接，默认进小程序。
      // 虚拟SKU：入口支持“生成海报”；用户打开链接，默认进H5。
      if (this.isXuniSku) {
        delete combineParam.miniProgramQrCodes
      }
      // let res = this.isXuniSku
      //   ? await this.$service.action(combineParam)
      //   : await this.$service.combine(combineParam)
      this.sharePicPop = true
      this.showPop = false
      // this.sharePic = 'data:image/png;base64,' + res.data.base64Value
      this.$service.growthValueTask({
        taskType: '100702'
      })
    },
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    }
  }
}
